import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d55a0a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { ref, onMounted, getCurrentInstance } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { getActivityList,addActivity,delActivity,getActivityDetail,editActivity,getCouponList } from '@/axios/smartMarket';
  import { ElMessage,ElLoading } from 'element-plus';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ercode',
  setup(__props) {

  let { proxy } = getCurrentInstance() as any;
  
  let tableData = ref([
    {name:'小程序码',sub:'扫码进入小程序首页，可用于线下海报宣传、扫码在线订房、扫码领取会员卡等场景',type:1},
    {name:'桌贴码',sub:'仅可贴在包厢内，客人快速扫码点餐使用',type:2}
  ])

  //下载二维码
  function downs(type:number){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '');
    let compid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id;
    let brandid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id;
    let urls = proxy.$uploadOP;
    if(location.origin.indexOf('mrt') > -1){
      urls = location.origin;
    }
    // let str = '';
    // if(type==1){
    //   str = `${urls}/admin/qrcode/createCompanyQrcode?brand_id=${brandid}&company_id=${compid}&page=pages/index/index&scene=1!${compid}`;
    // }
    // else{
    //   str = `${urls}/admin/qrcode/createRoomQrcode?brand_id=${brandid}&company_id=${compid}&page=pages/index/index&scene=9!`;
    // }
    // return str
    if(type==1){
      urls = `${urls}/admin/qrcode/createCompanyQrcode?brand_id=${brandid}&company_id=${compid}&page=pages/index/index&scene=1!${compid}`;
    }
    else{
      urls = `${urls}/admin/qrcode/createRoomQrcode?brand_id=${brandid}&company_id=${compid}&page=pages/index/index&scene=9!`;
    }
    const loading = ElLoading.service({
      lock: true,
      text: '下载中...',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    let xml = new window.XMLHttpRequest();
    xml.open('get',urls,true)
    xml.send();
    xml.onreadystatechange = function() {
      if(xml.readyState==4 && xml.status==200){
        // let infos = JSON.parse(xml.response);
        if(xml.response.indexOf('return_code') > -1){
          loading.close();
          let infos = JSON.parse(xml.response).return_msg;
          ElMessage(infos)
        }
        else{
          var link = document.createElement('a');
          link.href = urls;
          link.download = '下载';
          link.style.display = 'none'; 
          document.body.appendChild(link);
          link.click();
          link.remove();
          loading.close();
        }
      }
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(pageTitle, { title: "二维码下载" }),
    _createVNode(_component_el_table, {
      data: _unref(tableData),
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sub",
          label: "说明"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "260px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              onClick: ($event: any) => (downs(scope.row.type)),
              class: "down_a"
            }, "下载二维码", 8, _hoisted_1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})